import React from 'react';
import useStyle from './badgeAvatar.style';
import { Avatar } from '../../../atoms/Avatar';
import { FlatIcon } from '../../../atoms/Icons/FlatIcon';
import { classNames } from '../../../../helpers/style/classNames';

interface BadgeAvatarViewProps {
  prenom: string;
  nom: string;
  username?: string;
  ville: string;
  variant: 'leaderboard' | 'profile';
  source: string;
}

export const BadgeAvatarView = ({
  prenom,
  username,
  ville,
  variant,
  source
}: BadgeAvatarViewProps) => {
  const classes = useStyle();

  return (
    <div className={classNames([classes.root, classes[variant]])}>
      <Avatar
        alt={prenom}
        source={source}
        variant={`${variant === 'leaderboard' ? 'leaderboard' : 'small'}`}
      />
      <div className={classes.divInfos}>
        <p className={classes.infos}>{username}</p>
        {variant === 'leaderboard' && (
          <div className={classes.line1}>
            <FlatIcon size={'small'} icon={'MapMarker'} />
            <p className={classes.ville}>{ville}</p>
          </div>
        )}
      </div>
    </div>
  );
};
